import {
  Dispatch,
  KeyboardEventHandler,
  SetStateAction,
  useCallback,
  useEffect,
  useState,
} from "react";

export interface UseFocusHandler {
  setFocused: Dispatch<SetStateAction<boolean>>;
  handlePreviousFocus: KeyboardEventHandler<HTMLInputElement>;
}

export const useFocusHandler = (
  isValid: boolean,
  isEmpty: boolean,
  nextInputName?: string,
  previousInputName?: string
): UseFocusHandler => {
  const [focused, setFocused] = useState(false);

  useEffect(() => {
    if (isValid && focused) {
      const input = document.querySelector<HTMLInputElement>(
        `input[name="${nextInputName}"]`
      );
      if (input) {
        input.focus();
        input.select();
      }
    }
  }, [isValid]);

  const handlePreviousFocus = useCallback<
    KeyboardEventHandler<HTMLInputElement>
  >(
    (e) => {
      if (isEmpty && focused && e.key === "Backspace") {
        const input = document.querySelector<HTMLInputElement>(
          `input[name="${previousInputName}"]`
        );
        if (input) {
          input.focus();
        }
      }
    },
    [focused, isEmpty, previousInputName]
  );

  return { setFocused, handlePreviousFocus };
};
